const DEFAULT_LOCALE = 'en-US';
const DEFAULT_CURRENCY = 'USD';

export const formatPrice = (number, locale, currency) => {
    locale = locale ? locale : DEFAULT_LOCALE;
    currency = currency ? currency : DEFAULT_CURRENCY;

    let formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    });

    return !isNaN(number) ? formatter.format(number) : '-';
};


export const compactNumber = (number, maxDigits, locale) => {
    locale = locale ? locale : DEFAULT_LOCALE;
    maxDigits = maxDigits || 1;
    return new Intl.NumberFormat(locale, {
        notation: 'compact',
        maxDigits: maxDigits
    }).format(number);
};